<template>
  <div>
    <breadcrumbs :home="vessel.name + ': Fortify wine'"/>

      <v-card flat>
        <v-form v-model="valid" ref="form" :disabled="!edit">
          <v-container class="pt-6 px-6 purtrak-scrollable" fluid>

            <v-row dense>
              <v-col cols="6" sm="4" lg="3">
                <date-picker v-model="transaction.date" @change="refresh(false)"/>
              </v-col>
              <v-col class="text-caption ml-5 mt-3 grey--text">{{vesselContents}}</v-col>
            </v-row>

            <v-row dense>
              <v-col cols="6" sm="3" lg="2">
                <alcohol-input label="Volume"
                               :tare="vessel.tare" v-model="transaction.volume" :litres.sync="transaction.litres"
                               :disabled="!edit" :hint="vesselVolume"/>
              </v-col>
              <v-col>
                <v-btn x-small text class="mt-3" @click="allContents()">
                  Use all contents
                </v-btn>
              </v-col>
            </v-row>

            <v-row>
              <v-col cols="12">
                <v-text-field label="Comments" v-model="transaction.comments" outlined dense counter="255" :rules="[fieldRules.maxLength(255)]"/>
              </v-col>
            </v-row>

            <v-row dense v-if="!vessel.contents.userLicense || vessel.contents.alcoholType!=='Spirit'">
              <em>Only spirits under a User license can be used to fortify wine.</em>
            </v-row>
          </v-container>
        </v-form>

        <v-divider/>
        <v-card-actions class="px-6">
          <template v-if="transactionId && company.permissions.includes('production.write')">
            <v-switch v-if="transaction.date > company.excisePeriodEnd || edit" :disabled="dirty"
                      v-model="edit" label="Edit" hide-details class="mt-0"/>
            <div v-else class="grey--text">Cannot edit since excise filed to period end {{company.excisePeriodEnd | formatDate}}</div>
          </template>
          <v-spacer/>
          <v-btn :plain="edit" color="primary" @click="cancel">{{edit?'Cancel':'Done'}}</v-btn>
          <v-btn v-if="edit" color="primary" :loading="saving" @click="save">Save</v-btn>
        </v-card-actions>
      </v-card>

    <confirm-leave v-model="next"/>
  </div>

</template>

<script>
import {format} from 'date-fns'
import confirmLeave from '@/mixins/confirmLeave'

export default {
  name: 'ExciseVesselFortifyWine',
  mixins: [confirmLeave],
	props: {
    vesselId: {type:String,required:false},
    transactionId: {type:String, required:false}
	},
	data() {
		return {
      edit: false,
      vessel: {name:'',contents:{userLicense:true}},
      valid:true,
      saving:false,
      accounts: [],
      transaction: {vesselId:this.vesselId, date: format(new Date(), 'yyyy-MM-dd HH:mm:ss'),
                    volume: 0, litres: 0, comments: ''},
      dirty: false
		}
  },
  computed: {
    company() {
      return this.$store.getters.company;
    },
    vesselContents() {
      return this.vessel.contents.volume ? this.vessel.contents.alcoholName : '';
    },
    vesselVolume() {
      if (!this.transactionId)
        return this.vessel.contents.volume ? `${this.$number(this.vessel.contents.volume, 3)} ${this.vessel.contents?.alcoholType === 'Spirit'?'LAA':'litres'}` : '(empty)';
    }
  },
  watch: {
    calculateValue() {
      if (this.calculateValue)
        this.transaction.value = null;
      this.dirty = true;
    },
    value() {
      this.dirty = true;
    },
    transaction: {
      handler() {this.dirty = true;},
      immediate: true,
      deep: true
    }
  },
	async created() {
    if (this.transactionId) {
      const results = await this.$apiCall(`query ExciseVesselFortifyWine($id:ID!) {
                                                exciseVesselFortifyWine(id:$id) {
                                                  id,vesselId,date,volume,litres,comments
                                                }
                                              }`,
                                          {id:this.transactionId});
      if (results.error) {
        this.$nextTick(() => this.dirty = false);
        this.$router.back();
        return;
      }
      this.transaction = results.data.exciseVesselFortifyWine;
    }
    else
      this.edit = true;
    await this.refresh();
    this.$nextTick(() => this.dirty = false);
  },

	methods: {
    allContents() {
      this.transaction.volume = this.vessel.contents.volume;
      this.transaction.litres = this.vessel.contents.litres;
      this.transaction.kg = this.vessel.contents.kg;
    },
    async refresh() {
      const results = await this.$apiCall(`query ExciseVesselFortifyWine($id:ID!, $date:DateTime) {
                                                exciseVessel(id:$id) {
                                                  id,name,tare,
                                                  contents(date:$date) {alcoholType,alcoholName,userLicense,volume}
                                                }
                                              }`,
                                          {id:this.transaction.vesselId || this.vesselId, date:this.transaction.date});
      if (!results.error) {
        this.vessel = results.data.exciseVessel;
        this.$nextTick(() => {this.$refs.form.validate()});
      }
    },
    cancel() {
      this.$router.back();
    },
		async save() {
      if (this.valid) {
        this.transaction.value = this.calculateValue ? null : this.value;
        this.saving = true;
        const results = await this.$apiCall(`mutation ExciseVesselFortifyWine($input: ExciseVesselFortifyWineInput!) {
                                                exciseVesselFortifyWineCreate(input:$input) {id}
                                              }`,
                                            {input:this.transaction});
        this.saving = false;
        if (!results.error) {
          this.dirty = false;
          this.$router.back();
          this.$store.commit('setError', {type:'success',message:`${this.transactionId?'Updated':'Created'} fortify wine transaction for ${this.vessel.name}`});
        }
      }
		}
	}
}
</script>